import { useState } from 'react';

export default () => {
  // const [status, setStatus] = useState<'detail' | 'config'>('config');
  const [status, setStatus] = useState<'detail' | 'config'>('detail');
  return {
    status,
    setStatus
  };
};
